var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoHelpUsToImprove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_84_1",
    "data-name": "Component 84 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 51.733 51.733",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9142",
    "data-name": "Path 9142",
    d: "M25.867,8A25.867,25.867,0,1,0,51.733,33.867,25.862,25.862,0,0,0,25.867,8Zm0,46.727a20.86,20.86,0,1,1,20.86-20.86A20.881,20.881,0,0,1,25.867,54.727Zm12.287-15.27a2.5,2.5,0,0,0-3.525.323,11.394,11.394,0,0,1-17.523,0,2.5,2.5,0,0,0-3.849,3.2,16.419,16.419,0,0,0,25.22,0A2.5,2.5,0,0,0,38.153,39.457ZM17.523,32.2a3.338,3.338,0,1,0-3.338-3.338A3.334,3.334,0,0,0,17.523,32.2ZM34.211,25.94c-2.681,0-5.83,1.763-6.248,4.391a1.25,1.25,0,0,0,2.065,1.126l.991-.887a5.417,5.417,0,0,1,6.362,0l.991.887a1.249,1.249,0,0,0,2.065-1.126c-.4-2.628-3.546-4.391-6.227-4.391Z",
    transform: "translate(0 -8)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHelpUsToImprove);
export default __webpack_public_path__ + "static/media/ico-HelpUsToImprove.dce7c9c3d5175aa944b4d53ce3726292.svg";
export { ForwardRef as ReactComponent };